/** Section ids, targeted as URL hash anchors. */
export const ANALYTICS_SECTION_ID = {
  overview: 'coaching-analytics-section-overview',
  engagement: 'coaching-analytics-section-engagement',
  coaching: 'coaching-analytics-section-coaching',
} as const;

export type AnalyticsSection = keyof typeof ANALYTICS_SECTION_ID;
